import i18n from "i18next";

import type { Ailment, LateralLocation, Location } from "api/schemas/shared/Treatment";
import { capitalize } from "utils/string/capitalize";

import { translateLateralLocation } from "./translateLateralLocation";
import { translatePainLocation } from "./translatePainLocation";

interface Params {
  ailment: Ailment | null | undefined;
  lateral_location: LateralLocation | null;
  location: Location | null;
}

export function translateTreatment({ ailment, lateral_location, location }: Params): string {
  if (ailment && ailment === "fall_prevention") {
    return i18n.t("patients.ailments.fall_prevention");
  }

  if (ailment && ailment === "osteoporosis") {
    return i18n.t("patients.ailments.osteoporosis");
  }

  if (lateral_location && location && lateral_location === "undefined") {
    return translatePainLocation({ painLocation: location });
  }

  if (lateral_location && location) {
    return capitalize(
      `${translateLateralLocation(lateral_location)} ${translatePainLocation({ painLocation: location })}`
    );
  }

  return "";
}
